import { render, staticRenderFns } from "./GarmentDevForm.vue?vue&type=template&id=55a15ccd&scoped=true&"
import script from "./GarmentDevForm.vue?vue&type=script&lang=js&"
export * from "./GarmentDevForm.vue?vue&type=script&lang=js&"
import style0 from "./GarmentDevForm.vue?vue&type=style&index=0&id=55a15ccd&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55a15ccd",
  null
  
)

export default component.exports